import Vue from 'vue';
import Router from 'vue-router';
import Introduce from '@/components/introduce';
import Product from '@/components/product';
import proDetail from '@/components/proDetail';
import Company from '@/components/company';
import JoinUs from '@/components/joinus';
import Case from '@/components/case';

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Introduce',
            redirect: '/introduce',
        },
        {
            path: '/introduce',
            name: 'Introduce',
            components: {
                main: Introduce
            }
        },
        {
            path: '/product',
            name: 'product',
            components: {
                main: Product
            }
        },
        {
            path: '/prodetail',
            name: 'proDetail',
            components: {
                main: proDetail
            }
        },
        {
            path: '/company',
            name: 'Company',
            components: {
                main: Company
            }
        },
        {
            path: '/joinus',
            name: 'JoinUs',
            components: {
                main: JoinUs
            }
        },
        {
            path: '/case',
            name: 'Case',
            components: {
                main: Case
            }
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js